import { render, staticRenderFns } from "./PlantaoTypes.vue?vue&type=template&id=1a6f712f"
import script from "./PlantaoTypes.vue?vue&type=script&lang=js"
export * from "./PlantaoTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports